export default "__VITE_ASSET__GPLp4XLy__"